// Mui text field 에러 확인 함수
export const checkMuiError = (): boolean => {
  const errorElements = document.querySelectorAll<HTMLElement>(".Mui-error, .error, .isError")

  return Array.from(errorElements).some((el) => !el.classList.contains("Mui-disabled"))
}

export const checkDatePickerError = (): boolean => {
  const errorElements = document.querySelectorAll<HTMLElement>(".DatePickerCont.error")

  return Array.from(errorElements).some((el) => !el.classList.contains(".disabled"))
}

// 페이지가 로드될 때 자동으로 실행
export const observeMuiErrors = (callback: (hasError: boolean) => void): MutationObserver => {
  let previousErrorState: boolean | null = null

  const checkAndUpdate = () => {
    const hasError = checkMuiError() || checkDatePickerError()

    // 이전 상태와 다를 때만 callback 호출
    if (previousErrorState !== hasError) {
      previousErrorState = hasError
      callback(hasError)
    }
  }

  // 초기 실행
  checkAndUpdate()

  // MutationObserver를 사용하여 DOM 변경 감지
  const observer = new MutationObserver(() => {
    checkAndUpdate()
  })

  observer.observe(document.body, { childList: true, subtree: true })

  return observer
}
